import { render, staticRenderFns } from "./process9.vue?vue&type=template&id=39dcc037&scoped=true&"
import script from "./process9.vue?vue&type=script&lang=js&"
export * from "./process9.vue?vue&type=script&lang=js&"
import style0 from "./process9.vue?vue&type=style&index=0&id=39dcc037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dcc037",
  null
  
)

export default component.exports